import { render } from "./InspectionSettlement.vue?vue&type=template&id=1707a15f"
import script from "./InspectionSettlement.vue?vue&type=script&lang=js"
export * from "./InspectionSettlement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__